import { inject, Service } from '@angular/core';
import { HumanizePipe } from '@app/core/pipes/humanize.pipe';
import { AnalyticsService } from '@app/core/services/mixpanel/analytics.service';
import { type Dict } from 'mixpanel-browser';

export interface IPivotTableToolbarTrackingContext {
  configType: string;
  report: {
    id?: number;
    name: string;
  };
}

type TToolbarAction =
  | 'Create'
  | 'Update'
  | 'Delete'
  | 'Rename'
  | 'Duplicate'
  | 'Export';
@Service()
export class ToolbarMixpanelEventTrackingService {
  private _analyticsService = inject(AnalyticsService);
  private _humanizePipe = inject(HumanizePipe);

  private _track(
    action: TToolbarAction,
    context: IPivotTableToolbarTrackingContext,
    extraProperties: Dict = {},
  ): void {
    const eventType = this._humanizePipe.transform(context.configType);

    this._analyticsService.track(`${eventType}: ${action} Report`, {
      report_name: context.report.name,
      report_id: context.report.id,
      ...extraProperties,
    });
  }

  trackCreateReport(context: IPivotTableToolbarTrackingContext): void {
    this._track('Create', context);
  }

  trackUpdateReport(context: IPivotTableToolbarTrackingContext): void {
    this._track('Update', context);
  }

  trackDeleteReport(context: IPivotTableToolbarTrackingContext): void {
    this._track('Delete', context);
  }

  trackRenameReport(
    context: IPivotTableToolbarTrackingContext,
    newName: string,
  ): void {
    this._track('Rename', context, { new_name: newName });
  }

  trackDuplicateReport(
    context: IPivotTableToolbarTrackingContext,
    newName: string,
  ): void {
    this._track('Duplicate', context, { new_name: newName });
  }

  trackExportReport(context: IPivotTableToolbarTrackingContext): void {
    this._track('Export', context);
  }
}
